/* Octagon - zmiana zdjecia w oknie powiekszenia.

   PC (od 750 px): DZIALA - NIE RUSZAC.
     Gest gora-dol + kolko myszy, wlasna plynna animacja rAF, na jej czas
     scroll-snap wylaczony. Kolko blokujemy DOPIERO po udanej zmianie.

   MOBILE (do 749 px): gest w BOK.
     Zmiana przez KLIKNIECIE MINIATURY (metoda motywu) + korektor pozycji,
     ktory dociaga kadr po wygasnieciu rozpedu.
     Natychmiastowy scrollTo tu NIE dziala: natywny rozped gestu leci dalej
     i znosi ustawiona pozycje.

   PULAPKA, ktora kiedys zabila caly skrypt:
   widocznosc slajdow sprawdzana przez offsetParent - w oknie modalnym
   jest ZAWSZE null, wiec skrypt widzial zero zdjec. Liczymy przez
   getClientRects().

   NIE uzywac behavior 'smooth' na PC. NIE dotykac transform ani scale. */
(() => {
  const DIALOG = '.dialog-zoomed-gallery__dialog';
  const SLIDES = '.dialog-zoomed-gallery > *';
  const THUMBS = '.dialog-thumbnails-list__thumbnail';
  const MIN_DISTANCE = 50;
  const CHANGE_LOCK = 420;
  const DURATION = 300;
  const SNAP_TOLERANCE = 2;
  const SNAP_TICK = 90;
  const SNAP_MAX_MS = 1400;

  let lastChange = 0;
  let rafId = null;
  let snapTimer = null;

  const isMobile = () => window.innerWidth <= 749;

  function openDialog() {
    const d = document.querySelector(DIALOG);
    return d && d.open ? d : null;
  }

  function scaleOf(el) {
    if (!el) return 1;
    const t = getComputedStyle(el).transform;
    if (!t || t === 'none') return 1;
    const m = t.match(/matrix\(([^,]+),/);
    return m ? Math.abs(parseFloat(m[1])) || 1 : 1;
  }

  /* UWAGA: bez offsetParent - w oknie modalnym zawsze null */
  const isVisible = (el) =>
    el && !el.hidden && el.style.display !== 'none' && el.getClientRects().length > 0;

  const slidesOf = (dialog) =>
    Array.from(dialog.querySelectorAll(SLIDES)).filter(isVisible);

  const thumbsOf = (dialog) =>
    Array.from(dialog.querySelectorAll(THUMBS)).filter(isVisible);

  function currentIndex(slides) {
    const cx = window.innerWidth / 2;
    const cy = window.innerHeight / 2;
    let best = 0;
    let bestDist = Infinity;

    slides.forEach((s, i) => {
      const r = s.getBoundingClientRect();
      const dist = Math.hypot(r.left + r.width / 2 - cx, r.top + r.height / 2 - cy);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });

    return best;
  }

  function indexNow() {
    const dialog = openDialog();
    if (!dialog) return -1;
    const slides = slidesOf(dialog);
    return slides.length ? currentIndex(slides) : -1;
  }

  function markThumb(thumbs, index) {
    thumbs.forEach((t, i) => {
      const btn = t.tagName === 'BUTTON' ? t : t.querySelector('button');
      (btn || t).setAttribute('aria-selected', String(i === index));
    });
  }

  const locked = () => Date.now() - lastChange < CHANGE_LOCK;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  /* ---------- MOBILE: dociaganie kadru po rozpedzie ---------- */

  function keepSnapped(slide, box) {
    clearInterval(snapTimer);

    const started = Date.now();
    let stableTicks = 0;

    snapTimer = setInterval(() => {
      if (!openDialog() || Date.now() - started > SNAP_MAX_MS) {
        clearInterval(snapTimer);
        return;
      }

      const s = slide.getBoundingClientRect();
      const b = box.getBoundingClientRect();
      const dy = s.top - b.top;
      const dx = s.left - b.left;
      const off = Math.max(Math.abs(dy), Math.abs(dx));

      if (off <= SNAP_TOLERANCE) {
        stableTicks += 1;
        if (stableTicks >= 2) clearInterval(snapTimer);
        return;
      }

      stableTicks = 0;
      box.scrollTop += dy;
      box.scrollLeft += dx;
    }, SNAP_TICK);
  }

  /* ---------- PC: wlasna plynna animacja ---------- */

  function glide(dialog, toTop, toLeft) {
    if (rafId) cancelAnimationFrame(rafId);

    const fromTop = dialog.scrollTop;
    const fromLeft = dialog.scrollLeft;

    dialog.style.setProperty('scroll-snap-type', 'none');

    const start = performance.now();

    function frame(now) {
      const p = Math.min(1, (now - start) / DURATION);
      const e = easeOut(p);

      dialog.scrollTop = fromTop + (toTop - fromTop) * e;
      dialog.scrollLeft = fromLeft + (toLeft - fromLeft) * e;

      if (p < 1) {
        rafId = requestAnimationFrame(frame);
      } else {
        dialog.scrollTop = toTop;
        dialog.scrollLeft = toLeft;
        dialog.style.removeProperty('scroll-snap-type');
        rafId = null;
      }
    }

    rafId = requestAnimationFrame(frame);
  }

  function goTo(next) {
    const dialog = openDialog();
    if (!dialog) return false;

    const slides = slidesOf(dialog);
    if (slides.length < 2) return false;
    if (next < 0 || next >= slides.length) return false;

    lastChange = Date.now();

    const target = slides[next];

    /* --- MOBILE --- */
    if (isMobile()) {
      const thumbs = thumbsOf(dialog);
      const thumb = thumbs[next];

      if (thumb) {
        const btn = thumb.tagName === 'BUTTON' ? thumb : thumb.querySelector('button');
        (btn || thumb).click();
        markThumb(thumbs, next);
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
      }

      setTimeout(() => keepSnapped(target, dialog), 320);
      setTimeout(() => markThumb(thumbsOf(dialog), next), 700);
      return true;
    }

    /* --- PC --- */
    const dRect = dialog.getBoundingClientRect();
    const tRect = target.getBoundingClientRect();

    glide(
      dialog,
      dialog.scrollTop + (tRect.top - dRect.top),
      dialog.scrollLeft + (tRect.left - dRect.left)
    );

    markThumb(thumbsOf(dialog), next);
    setTimeout(() => markThumb(thumbsOf(dialog), next), 320);

    return true;
  }

  function handleGesture(dx, dy, slide, startIndex) {
    if (startIndex < 0 || locked()) return;

    const wrapper = slide && slide.querySelector('drag-zoom-wrapper');
    if (scaleOf(wrapper) > 1.05) return;

    const main = isMobile() ? dx : dy;
    const cross = isMobile() ? dy : dx;

    if (Math.abs(main) < MIN_DISTANCE) return;
    if (Math.abs(main) < Math.abs(cross)) return;

    goTo(startIndex + (main < 0 ? 1 : -1));
  }

  /* ---------- Dotyk ---------- */

  let tx = 0;
  let ty = 0;
  let tSlide = null;
  let tStart = -1;
  let tracking = false;

  document.addEventListener(
    'touchstart',
    (e) => {
      tracking = false;
      clearInterval(snapTimer);
      if (!openDialog()) return;
      if (e.touches.length !== 1) return;

      tx = e.touches[0].clientX;
      ty = e.touches[0].clientY;
      tSlide = e.target.closest ? e.target.closest(SLIDES) : null;
      tStart = indexNow();
      tracking = true;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    (e) => {
      if (!tracking) return;
      tracking = false;
      if (!e.changedTouches || e.changedTouches.length !== 1) return;

      handleGesture(
        e.changedTouches[0].clientX - tx,
        e.changedTouches[0].clientY - ty,
        tSlide,
        tStart
      );
    },
    { passive: true, capture: true }
  );

  /* ---------- Przeciaganie myszka ---------- */

  let mx = 0;
  let my = 0;
  let mSlide = null;
  let mStart = -1;
  let dragging = false;

  document.addEventListener(
    'pointerdown',
    (e) => {
      dragging = false;
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      if (!openDialog()) return;

      mx = e.clientX;
      my = e.clientY;
      mSlide = e.target.closest ? e.target.closest(SLIDES) : null;
      mStart = indexNow();
      dragging = true;
    },
    { capture: true }
  );

  document.addEventListener(
    'pointerup',
    (e) => {
      if (!dragging) return;
      dragging = false;
      if (e.pointerType === 'touch') return;

      handleGesture(e.clientX - mx, e.clientY - my, mSlide, mStart);
    },
    { capture: true }
  );

  /* ---------- Kolko myszy (tylko PC) ---------- */

  document.addEventListener(
    'wheel',
    (e) => {
      if (isMobile()) return;

      const dialog = openDialog();
      if (!dialog) return;

      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      if (Math.abs(e.deltaY) < 12) return;
      if (locked()) return;

      const target = e.target.closest ? e.target.closest(SLIDES) : null;
      const wrapper = target && target.querySelector('drag-zoom-wrapper');
      if (scaleOf(wrapper) > 1.05) return;

      const start = indexNow();
      if (start < 0) return;

      if (goTo(start + (e.deltaY > 0 ? 1 : -1))) e.preventDefault();
    },
    { passive: false, capture: true }
  );
})();
